import { isMobileBrowser } from '@rover/utilities/device';

import $ from '@rover/globals/jquery';
import _ from '@rover/globals/underscore';
import Backbone from '@rover/globals/backbone';
import dataLayer from '@rover/globals/dataLayer';
import Rover from '@rover/globals/Rover';

export default Backbone.View.extend({
  cookieName: 'email_capture_popup',

  initialize() {
    // Don't do anything if there is no email popup
    if (this.$el.length === 0) {
      return;
    }

    this.checkAndShowPopup();
    this.$el.on('hide.bs.modal', _.bind(this.doNotShowAgain, this));
  },

  checkAndShowPopup() {
    if (this.$el && !this.hasBeenDismissed() && !isMobileBrowser()) {
      this.showPopup();
    }
  },

  showPopup() {
    this.$el.modal();
    this.$('.js-email-capture-popup-form').ajaxForm({
      success: _.bind(this.showThanks, this),
      error: _.bind(this.showThanks, this),
    });
  },

  hasBeenDismissed() {
    return $.cookie(this.cookieName) === 'dismissed';
  },

  doNotShowAgain() {
    $.cookie(this.cookieName, 'dismissed', {
      expires: 365,
      path: '/',
    });
  },

  showThanks() {
    this.doNotShowAgain();
    this.$('.js-email-capture-popup-initial').fadeOut('fast', () => {
      this.$('.js-email-capture-popup-success').fadeIn('fast');
    });
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/email_capture_popup_view.js